<template>
    <div class="loading"></div>
</template>

<script>
export default {
  methods: {
  }
};
</script>


// WEBPACK FOOTER //
// src/global/Loading.vue